/* eslint-disable no-empty-pattern */
import axios from "axios";
import Vue from "vue";
import VueCookie from "vue-cookie";

import router from "../../router";
import { emitter } from "../../plugins/eventBus";
import service from "@/services/service.js";
import store from "@/store/index";
import { $themeBreakpoints } from "@themeConfig";
import { instance } from "../../config/index";

Vue.use(VueCookie);

const initialState = () => ({
  token: localStorage.getItem("token"),
  tokenProdOnStg: localStorage.getItem("tokenProdOnStg"),

  user: {},
  workspace: {},
  roles: [],
  currentRole: null,

  windowWidth: 0,

  shallShowOverlay: false,
  hasRouterNavigation: false,
  hasMktPlusAuthRequest: false,
});

const getters = {
  currentBreakPoint: (state) => {
    const { windowWidth } = state;

    if (windowWidth >= $themeBreakpoints.xl) return "xl";
    if (windowWidth >= $themeBreakpoints.lg) return "lg";
    if (windowWidth >= $themeBreakpoints.md) return "md";
    if (windowWidth >= $themeBreakpoints.sm) return "sm";

    return "xs";
  },

  getUserData(state) {
    return state.user;
  },

  getUserRole(state) {
    return state.currentRole;
  },

  getRoles(state) {
    return state.roles;
  },

  getUserWorkspaces(state) {
    return state.user.workspaces;
  },

  getUserWorkspace(state) {
    return state.workspace;
  },

  getAllRoles(state) {
    return state.roles;
  },
};

const mutations = {
  UPDATE_WINDOW_WIDTH(state, val) {
    state.windowWidth = val;
  },

  TOGGLE_OVERLAY(state, val) {
    state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay;
  },

  SET_TOKEN(state, token) {
    state.token = token;
  },

  SET_USER(state, user) {
    state.user = user;
  },

  SET_WORKSPACE(state, workspace) {
    state.workspace = workspace;
  },

  SET_ROLES(state, roles) {
    state.roles = roles;
  },

  SET_HAS_ROUTER_NAVIGATION(state, hasRouterNavigation) {
    state.hasRouterNavigation = hasRouterNavigation;
  },

  SET_CURRENT_ROLE(state, currentRole) {
    state.currentRole = currentRole;
  },

  SET_TOKEN_PROD_ON_STG(state, token) {
    state.tokenProdOnStg = token;
  },

  SET_HAS_MKT_PLUS_AUTH_REQUEST(state, hasMktPlusAuthRequest) {
    state.hasMktPlusAuthRequest = hasMktPlusAuthRequest;
  },

  SET_LOGOUT(state) {
    const inital = initialState();

    Object.keys(inital).forEach((key) => {
      state[key] = inital[key];
    });
  },
};

const actions = {
  async setCurrentWorkflow({ dispatch, commit }) {
    const workflowsResponse = await dispatch("fetchUserWorflows");
    const currentWorkflowId = service.getWorkflowId();

    const defaultWorkflow =
      workflowsResponse.data.find((w) => w.id == currentWorkflowId) ||
      workflowsResponse.data.find((w) => w.is_default) ||
      workflowsResponse.data[0];

    localStorage.setItem("currentWorkflow", JSON.stringify(defaultWorkflow));

    commit("SET_CURRENT_ROLE", defaultWorkflow.role);
  },

  async setToken({ commit, dispatch }, response) {
    const res = response.data;
    const token = res.access_token;
    const workspaceId = res.user.workspaces[0].id;
    const currentWorkspaceData = res.user.workspaces[0];

    if (res.imNic) {
      const imNicToken = res.imNic.access_token;
      const acessCode = res.user.access_code;

      localStorage.setItem("imNicToken", imNicToken);
      localStorage.setItem("acessCode", acessCode);
    }

    localStorage.setItem("token", token);

    localStorage.setItem("currentWorkspace", workspaceId);

    commit("SET_TOKEN", token);
    commit("SET_USER", res.user);
    commit("SET_WORKSPACE", currentWorkspaceData);

    await dispatch("setCurrentWorkflow");
  },

  setProdTokenOnStg({ commit }, response) {
    const token = response.data.access_token;

    localStorage.setItem("tokenProdOnStg", token);

    commit("SET_TOKEN_PROD_ON_STG", token);
  },

  authenticateMktPlus({ commit, dispatch }, token) {
    commit("SET_HAS_MKT_PLUS_AUTH_REQUEST", true);

    const body = {
      token,
      origin: "mariplace",
    };

    return new Promise((resolve, reject) => {
      instance()
        .post("/auth/validate-external-token", body)
        .then(async (response) => {
          await dispatch("setToken", response);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_HAS_MKT_PLUS_AUTH_REQUEST", false);
        });
    });
  },

  authUser({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      instance()
        .post("/auth/token", data)
        .then(async (response) => {
          await dispatch("setToken", response);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  requestProdTokenOnStg({ dispatch }, data) {
    const endpoint = "https://api.crm.imlabs.com.br/v1/auth/token";

    return new Promise((resolve, reject) => {
      axios
        .post(endpoint, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          dispatch("setProdTokenOnStg", response.data);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  createUserViaInviteAndLogin({ dispatch }, invitationData) {
    const postUrl = `user-invitations/${invitationData.user_invitation_id}/fulfill`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl, invitationData)
        .then(async (response) => {
          await dispatch("setToken", response);

          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  async changeCurrentWorkspace({ commit, dispatch }, currentWorkspace) {
    localStorage.setItem("currentWorkspace", currentWorkspace.id);

    await dispatch("setCurrentWorkflow");

    commit("SET_WORKSPACE", currentWorkspace);
  },

  getWorkspace({}, id) {
    return this.state.app.user.workspaces.filter((w) => w.id === id)[0];
  },

  fetchUserWorkspaces({}, parms) {
    return new Promise((resolve, reject) => {
      instance()
        .get(`/users/self/workspaces${parms || ""}`)
        .then((response) => {
          this.state.app.user.workspaces = response.data;
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchWorkspaceSettings({}, data) {
    const otherWorkspaceId = data.otherWorkspaceId;
    const workspaceId = otherWorkspaceId || localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .get(`/workspaces/${workspaceId}/settings${data.params || ""}`)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  fetchWorkspace({}, id) {
    return new Promise((resolve, reject) => {
      instance()
        .get(`users/self/workspaces/${id}`)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  saveWorkspaceSettings({}, workspaceSettings) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .post(`/workspaces/${workspaceId}/settings`, workspaceSettings)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  saveOtherWorkspaceSettings({}, workspaceSettings) {
    const postUrl = `workspaces/${workspaceSettings.workspaceId}/settings`;

    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl, workspaceSettings.distribution)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  saveWorkspace({}, workspace) {
    const postUrl = `users/self/workspaces`;

    if (workspace.id) {
      // Update
      return new Promise((resolve, reject) => {
        instance()
          .put(`${postUrl}/${workspace.id}`, workspace)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }

    // Insert
    return new Promise((resolve, reject) => {
      instance()
        .post(postUrl, workspace)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  /* PASSWORD AND INVITATION*/
  requestPasswordReset({}, data) {
    return new Promise((resolve, reject) => {
      instance()
        .put("/auth/request-password-reset", data)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  putResetPassword({}, data) {
    return new Promise((resolve, reject) => {
      instance()
        .put("/auth/reset-password", data)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  sendInvitation({}, data) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .post(`workspaces/${workspaceId}/user-invitations`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getUserInvitation({}, data) {
    return new Promise((resolve, reject) => {
      instance()
        .get(`/user-invitations/${data.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  postUserInvitation({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      instance()
        .post(`/user-invitations/${data.id}/fulfill`, data.data)
        .then(async (response) => {
          await dispatch("setToken", response);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getRoles({ commit }) {
    return new Promise((resolve, reject) => {
      instance()
        .get("/roles")
        .then((response) => {
          const res = response.data;

          commit("SET_ROLES", res);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchUsers({}, query) {
    /* TODO get data from id */
    return new Promise((resolve, reject) => {
      instance()
        .get(`/workspaces/${this.state.app.workspace.id}/users${query || ""}`)
        .then((response) => resolve(response))
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchUsersFromOtherWorkspace({}, info) {
    const postUrl = `/workspaces/${info.workspaceId}/users${info.params || ""}`;

    return new Promise((resolve, reject) => {
      instance()
        .get(postUrl)
        .then((response) => resolve(response))
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchUserWorflows({}) {
    const workspaceId = localStorage.getItem("currentWorkspace");
    const getUrl = `/workspaces/${workspaceId}/workflows`;

    return new Promise((resolve, reject) => {
      instance()
        .get(getUrl)
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  logout({ commit }) {
    return new Promise((resolve) => {
      localStorage.removeItem("token");
      localStorage.removeItem("imNicToken");
      localStorage.removeItem("acessCode");

      commit("SET_LOGOUT");
      store.commit("opportunityStore/SET_LOGOUT");
      store.commit("taskNotificationCards/clearCards");

      emitter.emit("logout");

      store.commit("omnichannelSocket/setConnectionStatus", "disconnected");
      store.commit("omnichannelSocket/setConnId", null);
      store.commit("omnichannelSocket/setWebsocket", null);

      if (router.currentRoute.path !== "/login") {
        router.push("/login").catch(() => {});
      }

      resolve();
    });
  },
};

export default {
  namespaced: true,
  state: initialState(),
  mutations,
  getters,
  actions,
};
